module.exports = __webpack_public_path__ + "img/xinxizixun.2954341c.png";